import { FC, useCallback, useRef, useState } from "react";
import FormLayout from "../../FormLayout";
import DropZone from "./components/DropZone";
import ModuleItem from "./components/ModuleItem";
import CheckModules from "./components/CheckModules";
import { Button } from "@mui/material";
import { useToast } from "../../../../hooks/useToast";
import furnitureController from "../../../../Api/furnitureController";
import LoadingAnimation from "../../../_common/Loading";

interface AddModulesFormProps {
    furnitureId: string;
}

const AddModulesForm: FC<AddModulesFormProps> = ({
    furnitureId,
}) => {
    const [newModules, setNewModules] = useState<any[]>([]);
    const [pushModules, setPushModules] = useState<boolean>(false);
    const [modulesToPush, setModulesToPush] = useState<any[]>([]);
    const [mode, setMode] = useState<'add' | 'check'>('add')
    const [loading, setLoading] = useState<boolean>(false)
    const toast = useRef(useToast()).current


    const handleAddModules = useCallback(async () => {
        setPushModules(false)
        setModulesToPush([])
        setLoading(true)

        for (const item of modulesToPush) {
            const module = {
                name: item.name,
                width: item.width,
                depth: item.depth,
                height: item.height,
                description: item.description,
                moduleType: item.moduleType,
                image: item.image[0],
                randomKey: item.randomKey,
            }

            try {
                if (!item.name || !item.image) {
                    toast.error('Brak niezbędnych danych')
                    setLoading(false)
                    return;
                }

                const res = await furnitureController.addModuleToFurniture(furnitureId, module)

                if (!res.ok) {
                    toast.error('Nie udało się dodać modułu')
                    return setLoading(false)
                }

            } catch (error) {
                if (error instanceof Error) {
                    toast.error(error.message)
                }
                setLoading(false)
            }
        }

        toast.success('Moduł dodany pomyślnie')
        setLoading(false)
        window.location.reload()
    }, [
        furnitureId,
        modulesToPush,
        toast,
    ])


    const handleChangeModulesToPush = useCallback((module: any) => {
        setModulesToPush((prevModules) => [...prevModules, module]);
        setMode('check')
    }, [])


    const removeModuleForm = useCallback((moduleKey: string) => {
        setPushModules(false)
        setNewModules((prevModules) =>
            prevModules.filter((module) => module.randomKey !== moduleKey)
        );
    }, [])

    if (loading) return (
        <FormLayout title="Ładowanie">
            <LoadingAnimation />
        </FormLayout>
    )

    return (
        <FormLayout
            title="Dodaj moduły"
            maxWidth='xl' disableClose
            buttonText={mode === 'add' ? 'Dalej' : 'Dodaj moduły'}
            onClickButton={() => {
                if (newModules.length === 0) return
                if (mode === 'add') {
                    setPushModules(true)
                }
                if (mode === 'check') {
                    handleAddModules()
                }
            }}
        >
            {newModules.map((module, index) => (
                <ModuleItem
                    mode={mode}
                    key={module.randomKey}
                    module={module}
                    index={index}
                    onRemoveModule={removeModuleForm}
                    pushModules={pushModules}
                    onSetModulesToPush={handleChangeModulesToPush}
                />
            ))}
            <CheckModules
                mode={mode}
                modules={modulesToPush}
            />
            {
                mode === 'add' ? (
                    <DropZone onSetModules={setNewModules} />
                )
                    :
                    mode === 'check' && (
                        <Button
                            sx={{ width: '100%' }}
                            variant='contained'
                            color="error"
                            onClick={() => {
                                setMode('add')
                                setPushModules(false)
                                setModulesToPush([])
                            }}
                        >
                            popraw
                        </Button>
                    )
            }
        </FormLayout>
    )
}

export default AddModulesForm;